import React from "react";
import styles from "../TextOnly/textOnly.module.css";
import Animations from "../Animations/animations";

const TextOnly = ({ content, width }) => {
  return (
    <section className={styles.textOnlySec}>
      <div className={styles.container}>
        {content.map((contentItem, index) => (
          <div key={index}>
            <Animations animationType="fadeInUp" threshold={0.2}>
            <h2>{contentItem.heading}</h2>
           

            <p  style={width ? { width: "70%", margin:"15px auto 0" } : {width: "100%"}}
              dangerouslySetInnerHTML={{
                __html: contentItem.subText
                  ? contentItem.subText.replace(/\n/g, "<br />") // Replace newlines with <br />
                  : contentItem.subText, // If subText is undefined or null, display an empty string
              }}
            />
             </Animations>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TextOnly;
